import { useEffect, useState } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';

// A Video card's file's download URL, from its storage path
const useVideoSrc = (storagePath: string | undefined) => {
  const [videoSrc, setVideoSrc] = useState<string | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!storagePath) {
      return;
    }
    let isActive = true;
    setIsLoading(true);
    firebase
      .storage()
      .ref(storagePath)
      .getDownloadURL()
      .then((downloadUrl: string) => {
        if (isActive) {
          setVideoSrc(downloadUrl);
          setIsLoading(false);
        }
      });
    return () => {
      isActive = false;
    };
  }, [storagePath]);

  return { videoSrc, setVideoSrc, isLoading };
};

export default useVideoSrc;
